import { useEffect, useState } from "react";
import { useServerHealthCheck } from "./queries/useServerHealthCheck";

const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const { isError: isServerOffline } = useServerHealthCheck();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    isOnline: isOnline && !isServerOffline,
    isServerOnline: !isServerOffline,
  };
};

export default useOnlineStatus;
